import React from 'react';
import { Field } from 'react-final-form';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Condition from '../../../../../../../components/Condition';
import Input from '../../../../../../../components/Input';
import RadioGroup from '../../../../../../../components/RadioGroup';
import DrivingLicense from '../../../../../../../icons/DrivingLicense';
import conditionalValidation from '../../../../../../../validators/conditionalValidation';
import fieldRequiredStandard from '../../../../../../../validators/fieldRequired';
import SectionTitle from '../../../../../common/SectionTitle';
import { useStandaloneWizardState } from '../../../../../standalone-wizard/StandaloneWizardProvider';

import styles from './OwnershipAndLicensingDisclosureDC.module.scss';

const OwnershipAndLicensingDisclosureDC = ({ className }) => {
  const { standAloneWizard } = useStandaloneWizardState();
  const fieldRequired = conditionalValidation(
    fieldRequiredStandard,
    !standAloneWizard,
  );

  return (
    <div className={cx(styles.container, className)}>
      <SectionTitle
        title="Ownership and License Disclosure"
        icon={DrivingLicense}
        className={styles.sectionTitle}
      />
      <label className={styles.label}>
        Do you have your ownership and business license information?
      </label>
      <p className={styles.description}>
        District of Columbia law requires disclosure of ownership and business
        license information.
      </p>
      <Field
        component={RadioGroup}
        id="custom_state_data.ownership_licensing_disclosure"
        name="custom_state_data.ownership_licensing_disclosure"
        radiosContainerClassName={styles.radioButtonsContainer}
        options={[
          {
            id: 'ownership_licensing_disclosure_yes',
            value: true,
            label: 'Yes',
          },
          {
            id: 'ownership_licensing_disclosure_no',
            value: false,
            label: 'No',
          },
        ]}
        validate={fieldRequired}
      />
      <Condition
        when="custom_state_data.ownership_licensing_disclosure"
        is={true}
      >
        <Field
          as="textarea"
          component={Input}
          id="custom_state_data.ownership_licensing_explanation"
          name="custom_state_data.ownership_licensing_explanation"
          label="Please list your property ownership information and business license
            number. You will need to attach a copy of your business
            registration:"
          className={styles.termsContainer}
          inputProps={{
            rows: '5',
            className: styles.termsField,
          }}
          maxLength={2000}
          validate={fieldRequired}
          help={(val = '') => `${val.length} / 2000 characters used`}
        />
      </Condition>
    </div>
  );
};

OwnershipAndLicensingDisclosureDC.propTypes = {
  className: PropTypes.string,
};

export default OwnershipAndLicensingDisclosureDC;
